import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FolderI } from 'src/app/models/folder';
import { PublicationPayloadService } from 'src/app/online/publication/service/publicationPayload.service';
import { PublicationSaveTypeE } from '../../publication-save-in-folder-dialog/publication-save-in-folder-dialog.component';

@Component({
    selector: 'app-folder-shared-selector',
    templateUrl: './folder-shared-selector.component.html',
    styleUrls: ['./folder-shared-selector.component.scss']
})
export class FolderSharedSelectorComponent implements OnInit {
    @Input() publicationId?: number;
    @Input() publicationType: PublicationSaveTypeE = PublicationSaveTypeE.DOCUMENT;
    @Input() selectedFolderId?: number;
    // The parent knows the up-to-date state of the publication (eg. a book's current bookParts,
    // or a document's current version) and is the only one able to tell whether a folder that
    // already contains the publication is holding a stale copy of it.
    @Input() isFolderOutdated?: (folder: FolderI) => boolean;
    @Input() updateOutdatedFolder?: (folder: FolderI) => Promise<void>;

    @Output() folderSelect = new EventEmitter<FolderI>();

    folders: FolderI[] = [];
    foldersLoading = false;

    constructor(private publicationPayloadService: PublicationPayloadService) {}

    ngOnInit(): void {
        this.foldersLoading = true;
        this.publicationPayloadService.prepareStoreShared().subscribe({
            next: result => {
                this.folders = result.folderList || [];
                this.foldersLoading = false;
            },
            error: () => (this.foldersLoading = false)
        });
    }
}
